module.exports = __webpack_public_path__ + "img/pro-xtIcon4.8eac4281.png";